'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

var _baseIcons = require('@bibliocommons/base-icons');

var _baseButtons = require('@bibliocommons/base-buttons');

require('../styles/TagPill.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TagPill = function (_BcReactComponent) {
  _inherits(TagPill, _BcReactComponent);

  function TagPill(props) {
    _classCallCheck(this, TagPill);

    var _this = _possibleConstructorReturn(this, (TagPill.__proto__ || Object.getPrototypeOf(TagPill)).call(this, props));

    _this.bindAll('handleFocus', 'handleBlur');

    _this.state = {
      focused: false
    };
    return _this;
  }

  _createClass(TagPill, [{
    key: 'handleFocus',
    value: function handleFocus() {
      this.setState({
        focused: true
      });
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur() {
      this.setState({
        focused: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          value = _props.value,
          className = _props.className,
          url = _props.url,
          renderIcon = _props.renderIcon,
          handleClick = _props.handleClick,
          handleRemove = _props.handleRemove,
          isLoading = _props.isLoading,
          otherProps = _objectWithoutProperties(_props, ['value', 'className', 'url', 'renderIcon', 'handleClick', 'handleRemove', 'isLoading']);

      var renderedIcon = renderIcon && renderIcon();
      var tagIcon = renderedIcon && _react2.default.createElement(
        'span',
        { className: 'tag-icon' },
        renderedIcon
      );

      var tagLink = url && _react2.default.createElement(
        'a',
        { href: url, onClick: handleClick, className: 'tag-link' },
        value
      );

      var removeButton = (handleRemove || isLoading) && _react2.default.createElement(
        _baseButtons.IconButton,
        { className: 'remove-tag-button', isLoading: isLoading, handleClick: handleRemove, spinnerPrimary: !!tagLink },
        _react2.default.createElement(_baseIcons.Cross, { className: 'extra-extra-small' }),
        _react2.default.createElement(
          _baseScreenReaderMessage2.default,
          null,
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'remove_tag', values: { value: value } })
        )
      );

      var classNames = (0, _classnames2.default)('cp-tag-pill', className, {
        focused: this.state.focused,
        clickable: !!tagLink
      });

      return _react2.default.createElement(
        'span',
        _extends({ className: classNames }, otherProps, { onFocus: this.handleFocus, onBlur: this.handleBlur }),
        tagIcon,
        ' ',
        tagLink || value,
        ' ',
        removeButton
      );
    }
  }]);

  return TagPill;
}(_baseBcReactComponent2.default);

exports.default = TagPill;


TagPill.propTypes = {
  value: _react.PropTypes.string.isRequired,
  className: _react.PropTypes.string,
  url: _react.PropTypes.string,
  renderIcon: _react.PropTypes.func,
  handleClick: _react.PropTypes.func,
  handleRemove: _react.PropTypes.func,
  isLoading: _react.PropTypes.bool
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/tag-pill/lib/components/TagPill.component.js
// module id = 1547
// module chunks = 1